import { Badge, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';

interface AppBadgeProps {
  invisible: boolean;
  badgeContent: string;
  title?: string;
  fullWidth?: boolean;
  testId?: string;
}

const rootStyles = (fullWidth: boolean | undefined) => (theme: Theme) => ({
  width: fullWidth ? '100%' : undefined,
  fontWeight: 'bold',
});

export function AppBadge({
  children,
  invisible,
  badgeContent,
  title,
  fullWidth = false,
  testId,
}: PropsWithChildren<AppBadgeProps>) {
  return (
    <Badge
      invisible={invisible}
      badgeContent={badgeContent}
      color='primary'
      title={!invisible ? title : undefined}
      sx={rootStyles(fullWidth)}
      data-testid={testId}
    >
      {children}
    </Badge>
  );
}
